import { Avatar } from '@/components/ui/Avatar'
import { Card } from '@/components/ui/Card'
import { TypeClientBadge } from './TypeClientBadge'
import { Mail, Phone } from 'lucide-react'
import { formatDate } from '@/lib/utils'
import type { Client } from '@/types/client'

interface ClientDetailHeaderProps {
  client: Client
}

export function ClientDetailHeader({ client }: ClientDetailHeaderProps) {
  return (
    <Card padding="md">
      <div className="flex flex-col sm:flex-row items-start gap-6">
        <Avatar
          src={client.avatar_url}
          name={client.full_name}
          size="xl"
        />
        <div className="flex-1">
          <div className="flex flex-wrap items-center gap-3">
            <h1 className="text-2xl font-bold text-brown-900">
              {client.full_name}
            </h1>
            <TypeClientBadge type={client.type_client} />
          </div>
          {client.company && (
            <p className="text-lg text-brown-600 mt-1">{client.company}</p>
          )}
          <div className="flex flex-wrap items-center gap-4 mt-3 text-sm text-brown-500">
            <span className="flex items-center gap-1">
              <Mail className="w-4 h-4" /> {client.email}
            </span>
            {client.phone && (
              <span className="flex items-center gap-1">
                <Phone className="w-4 h-4" /> {client.phone}
              </span>
            )}
          </div>
        </div>
        <div className="text-right">
          <p className="text-sm text-brown-500">Client depuis</p>
          <p className="font-medium text-brown-900">{formatDate(client.created_at)}</p>
        </div>
      </div>
    </Card>
  )
}
